import { render, staticRenderFns } from "./QualifiedPage.vue?vue&type=template&id=1b21af97&"
import script from "./QualifiedPage.vue?vue&type=script&lang=js&"
export * from "./QualifiedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports